module.exports = __webpack_public_path__ + "static/img/icon_signin_man.3557d8b0.svg";